import {Component, useCallback, useState} from 'react';
import {Loading} from '../_elementos/Loading';
import {Http, Routes} from '../_api/Api';
import ApiConta from '../_api/ApiConta';
import Toast from '../_util/Toast';
import FormCadastroVerificar from "../_elementos/form/FormCadastroVerificar";
import FormCadastro from "../_elementos/form/FormCadastro";
import useLoading from "../_lib/hooks/useLoading";
import useJson from "../_lib/hooks/useJson";
import AuthLayout from "../_elementos/layout/AuthLayout";

import '../_util/YupInit';

const routes = new Routes();

export class FormResult extends Component {
    render() {
        return <div className="auth-sesc-success" role="status">
            <span className="auth-sesc-success-icon"><i className="fa fa-check" aria-hidden="true"/></span>
            <h3>Conta criada com sucesso!</h3>
            <p>Enviamos um link de confirmação para seu e-mail. Verifique também a caixa de spam.</p>
            <p>Depois, entre na sua conta para solicitar a credencial Sesc RN, completar seu endereço e acompanhar o atendimento.</p>
            <a className="btn btn-sesc-blue w-100" href={routes.get('/conta/login')}>
                Entrar na minha conta
            </a>
        </div>;
    }
}

export interface FormDataCadastro {
    nome: string;
    cpf: string,
    data_nascimento: string;
    email: string;
    telefone: string;
    senha: string;
}

export default function PageCadastro() {
    const routes = new Routes(),
        [loading, startLoading, stopLoading] = useLoading(),
        [step, setStep] = useState<number>(0),
        [data, setData] = useJson<FormDataCadastro>();

    const titles = [
        ['Crie sua conta', 'Primeiro, confirme seus dados pessoais'],
        ['Complete seu cadastro', 'Defina seus dados de acesso ao Espaço Digital'],
        ['Tudo pronto!', 'Sua conta foi criada com segurança']
    ];

    function verificarUsuario({cpf, data_nascimento}: FormDataCadastro) {
        startLoading();
        setData({cpf, data_nascimento});

        ApiConta.verificar({
            nucpf: cpf.replace(/[-.]/g, ''),
            dtnascimen: data_nascimento
        }).then(({status, data}) => {
            if (Http.isOk(status))
                setStep(1);
            else {
                const message = typeof data === 'object' ? data?.message : null;
                Toast.error(message || 'Não foi possível confirmar os dados.');
            }
        }).catch(e => {
            Toast.error(e?.data?.message || e?.message || 'Não foi possível confirmar os dados.');
        }).finally(() => {
            stopLoading();
        })
    }

    const cadastrarUsuario = useCallback(({nome, email, senha, telefone}: Partial<FormDataCadastro>) => {
        startLoading();
        setData({nome, email, telefone});

        const {data_nascimento, cpf} = data;
        ApiConta.cadastrar({
            nome, email, telefone, senha,
            data_nascimento,
            cpf: cpf.replace(/[-.]/g, '')
        }).then(({status, data}) => {
            if (Http.isCreated(status))
                setStep(2);
            else Toast.error(data?.message || 'Não foi possível criar sua conta.');
        }).catch(e => {
            Toast.error(e?.data?.message || e?.message || 'Não foi possível criar sua conta.');
        }).finally(stopLoading);
    }, [data]);

    const renderForm = useCallback(() => {
        switch (step) {
            case 0:
                return <FormCadastroVerificar key={step} onSubmit={verificarUsuario} initial={data}>
                    <div className="auth-sesc-switch">
                        <span>Já possui conta?</span>
                        <a href={routes.get("/conta/login")}>Entrar</a>
                    </div>
                </FormCadastroVerificar>;
            case 1:
                return <FormCadastro key={step} onSubmit={cadastrarUsuario} initial={data}/>;
            case 2:
                return <FormResult key={step}/>;
        }
    }, [step]);

    return <AuthLayout title={titles[step][0]} subtitle={titles[step][1]}
                       progress={{current: step + 1, steps: ['Identificação', 'Acesso', 'Concluído']}}>
        <div className="auth-sesc-form">
            {loading ? <Loading/> : renderForm()}
        </div>
    </AuthLayout>;
}
